import Vue from 'vue'
import Router from 'vue-router'
import store from "../store/index";

import {
	Dashboard,
	menumanage,
	rolemanage,
	userManage,
	systemLogs,
	userformrole,
  department,
  memberlist,
  memberrecord,
  customlist,
  customrecord,
  goodsList,
  goodsCategory,
  enterpriseTarget,
  teamTarget,
  personalTarget,
  revenueRecord,
  expenseRecord,
  statistics,
  vipcourselist,
  comcourselist,
  normalcustom,
  customUserlist,
  servicerecord,
  myrecord,
  mymember,
  record,
} from "./export";

// 进度条动画
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({
  showSpinner: false
})
Vue.use(Router)

// 公共路由配置
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: {
		name: "login"
	  }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/page/login/login.vue')
    },
    {
      path: "/home",
      name: "home",
      component: () => import("@/page/home/home.vue"),
      redirect: "/dashboard",
				children: [
				Dashboard,
				menumanage,
				rolemanage,
				userManage,
				systemLogs,
				userformrole,
        department,
        memberlist,
        memberrecord,
        customlist,
        customrecord,
        goodsList,
        goodsCategory,
        enterpriseTarget,
        teamTarget,
        personalTarget,
        revenueRecord,
        expenseRecord,
        statistics,
        vipcourselist,
        comcourselist,
        normalcustom,
        customUserlist,
        servicerecord,
        myrecord,
        mymember,
        record,
			],
		},
    {
      path: "/401",
      component: () => import("@/page/401.vue")
    },
    {
      path: "*",
      component: () => import("@/page/404.vue")
    }
  ]
})

//路由跳转前
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.path === "/login") {
    next();
  } else {
    const token = sessionStorage.getItem("token");
    if (!token) {
      next("/login");
    } else {
      next();
    }
  }
});
//路由跳转后
router.afterEach(() => {
  NProgress.done();
});

// 根据权限  对路由动态添加
export function initDynamicRoute() {
  //拿到home路由下的children
  const currentRoutes = router.options.routes;
  //拿到储存在vuex中的权限信息
  const systemList = store.state.systemList;
  // 对权限信息进行处理,找到与之匹配的  路由
  systemList.forEach(item => {});
  //动态的添加到路由中
  // currentRoutes[2].children.push()
  router.addRoutes(currentRoutes);
}


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js